/* MainContext */
import Addon from '@shared/classes/addon';
import Event from '@shared/classes/event';
import Rail from '@shared/classes/rail';
import Setting from '@shared/classes/setting';
import Slider from '@shared/classes/slider';
import { createContext } from 'react';
import { MainConfig } from '@shared/types/interfaces/main';

/**
 * `asset`/`category`/`layout`/`selection` are intentionally excluded - they
 * changed every keystroke and forced every consumer to re-render. They now
 * live in the `main` Redux slice, read via scoped `useAppSelector`s (e.g.
 * `useRail` reads only its own layout entry).
 */
interface MainContextProps {
  channels?: Rail;
  config: MainConfig;
  filter?: Rail;
  loading?: boolean;
  rails?: Rail[];
  sliders?: Slider[];
  changeAsset: (id: string, index: number) => void;
  hoverAsset: (asset: Addon | Event | Setting) => void;
  selectAsset: (id: string, index: number) => void;
}

const MainContext = createContext<MainContextProps>({
  config: {
    display: {
      channels: false,
      description: false,
      filter: false,
      message: false,
      sliders: false,
      search: false,
      timeline: false,
    },
    threshold: {
      front: 0,
      rear: 0,
    },
  },
  filter: undefined,
  loading: false,
  rails: undefined,
  sliders: undefined,
  changeAsset: () => null,
  hoverAsset: () => null,
  selectAsset: () => null,
});

export default MainContext;
export type { MainContextProps };
